import { BaseEntity } from './../../../base-models/base-entity';
import { BaseContainerService } from './base-container-service';
import { Injectable } from '@angular/core';
import { Subject, Observable, interval } from 'rxjs';
import { ModelData } from '../../../base-models/model-data';

@Injectable({
    providedIn: 'root'
})
export class Tabs2ContainerService<T extends BaseEntity> extends BaseContainerService<T> {
    constructor(){
        super();
    }

    random: number = Math.random();

    private activeTabSubject2: Subject<string> = new Subject<string>();

    ActiveTab2: Observable<string> = this.activeTabSubject2.asObservable();

    IsListTabDisabled = false;
    IsUpdateTabDisabled = true;

    name;

    ShowList(){
        this.selectTab('tbList2');
    }

    ShowUpdate(){
        this.selectTab('tbUpdate2');
    }

    AddItem(){
        console.log('Tabs2ContainerService:'+ "AddItem");
        this.IsUpdateTabDisabled = false;
        setTimeout(() => {
            this.selectTab('tbUpdate2');
            this.IsListTabDisabled = true;            
        }, 100);
        this.SelectItem(-1);
        //interval(1000)
            //.subscribe(i => {                
                //this.SelectItem(-1)
            //})      
        //this.delay(5000);
        //this.SelectItem(-1);
        //alert('Add item tabs container service');
    }

    EditItem(modelData: ModelData, ID: number){
        this.IsUpdateTabDisabled = false;
        setTimeout(() => {           
            this.selectTab('tbUpdate2');
            this.IsListTabDisabled = true;
        }, 100);
        this.SelectItem(ID);
    }

    private selectTab(tabID: string){
        this.activeTabSubject2.next(tabID);
    }

    //private async delay(ms: number){
        //return new Promise(resolve => setTimeout(resolve, ms));
    //}
}